import axios from "axios";
import React, {useEffect, useState, useRef, Fragment} from "react";
import {Link, NavLink, useParams, useNavigate, useLocation} from "react-router-dom"
import {render} from "react-dom";
import clientconfigwebapp, {
    empty_bk,
    convert_to_english_strhk,
    scrollTo_uphk,
    check_login_appbk,
    Token_get_appbk,
    redirectbh_typeb,
    FormatNumberByhkh,
    Cart_get_list_product,
} from '../../../../clientconfigwebapp';
import {ToastContainer, toast} from 'react-toastify';

import Master_Front from "../../../../pages/Master_Front";

import "../../../../components/assets/css/profile.css"

import ReactFullPageLoadinghk from "../../../../components/layaout/LoadingFullpagehk";
import Plyr_online_Component from "../../../../components/Player/Plyr_online_Component";


import ArvanPlayerComponent from "../../../../components/Player/ArvanPlayerComponent";
import NegavidPlayerComponent from "../../../../components/Player/NegavidPlayerComponent";
import Meeting_view from "../../../../components/Meeting/Meeting_view";

import Grid from '@mui/material/Grid';
import banner from "../../../../assets/img/Rectangle 305.png";
import Alert from "@mui/material/Alert";
import NegavidPlayer_pocast_Component from "../../../../components/Player/NegavidPlayer_pocast_Component";
import NegavidNewPlayerComponent from "../../../../components/Player/NegavidNewPlayerComponent";


const serialize = require('form-serialize');

const drawerWidth = 240;
const Metting_Panel = (props) => {

    const location_get_urlbk = useLocation();
    const redirect_navigate = useNavigate();
    const [loadinghkfullshow, Setloadinghkfullshow] = useState("false");

    /*  start profile */
    const [wallet_balance, setData_wallet_balance] = useState('0');
    const [first_name_profile, setData_first_name_profile] = useState('');
    const [last_name_profile, setData_last_name_profile] = useState('');
    const [list_order_get, setData_list_order] = useState([]);
    /*  end profile */


    const [total_cource_order, setData_total_cource_order] = useState('0');
    const [total_class_order, setData_total_class_order] = useState('0');
    const [first_name_last_name, setData_first_name_last_name] = useState('');


    const [list_cource_order, setData_list_cource_order] = useState('');
    const [status_empty_page, set_status_empty_page] = useState('');

    const [palyer_type, set_palyer_type] = useState('arvan');
    const [video_lesson, set_video_lesson] = useState('');


    const {window} = props;
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const [page_info_data, setData_Page_info] = useState([]);
    const [status_messege_buy_course, setStatus_messege_buy_course] = useState(false);
    const {id_post_getuser, lesson_id} = useParams();

    const params = useParams();
    const post_type = params.post_type && params.post_type.trim() !== "" ? params.post_type : "video";


    useEffect(() => {
        scrollTo_uphk();
        if (check_login_appbk() == false) {
            redirect_navigate("/login", {replace: true});
        }

        Load_api_page();
    }, [location_get_urlbk]);


    const scroll_to_viewbk = () => {
        ////console.log("bb","222")
        const active_item_c_get = document.getElementsByClassName('active_item_c')[0];
        var active_item_c_get_position = active_item_c_get.offsetTop;
        //// console.log("posssssssssssss1",active_item_c_get_position);
        active_item_c_get_position = (parseInt(active_item_c_get_position) - 80);
        active_item_c_get_position = parseInt(active_item_c_get_position);
        //// console.log("posssssssssssss2",active_item_c_get_position);
        const side_bar_metting = document.getElementById('side_bar_metting');


        if (side_bar_metting) {
            if (active_item_c_get) {
                ////  side_bar_metting.scrollTop=300;
                side_bar_metting.scrollTop = active_item_c_get_position;
            }
        }


    }


    const Load_api_page = () => {
        setStatus_messege_buy_course(false);
        setData_Page_info([]);
        set_palyer_type('arvan');
        if (check_login_appbk() == false) {
            redirect_navigate("/login", {replace: true});
        }

        const config = {
            headers: {Authorization: `Bearer ${Token_get_appbk()}`}
        };

        const data_form = {course_id: id_post_getuser, lesson_id: lesson_id,
            supports_negavid_new_player: true,
            post_type: post_type ? (post_type === 'podcast' ? 'podcast' : 'video') : 'video'
        };
        console.log(id_post_getuser, "course_idcourse_id")
        console.log(lesson_id, "lesson_idlesson_id")
        console.log(post_type, "post_type")




        axios.post(`${clientconfigwebapp.siteurl}api/v1/panel/course-view`, data_form, config)
            .then((res) => {
                ///  console.log(res.data);

                if (String(res.data).length > 0) {
                    ///console.log("rrrrrrrrrrrr");


                    if (String(res.data.data).length > 0) {
                        if (String(res.data.data) == "login-show") {
                            redirect_navigate("/login", {replace: true});
                        }


                        if (String(res.data.data) == "buy_course") {
                            setStatus_messege_buy_course(true);
                        } else {
                            setData_Page_info(res.data.data[0]);
                            ////////scroll_to_viewbk();
                        }


                        set_palyer_type(res.data.data[0].palyer_type || 'arvan');

                        if (String(res.data.data[0].video_lesson).length > 0) {
                            set_video_lesson(String(res.data.data[0].video_lesson));
                        }


                    } else {
                        if (String(res.data.msgwebapp).length > 0) toast.error(res.data.msgwebapp, {
                            position: "top-center",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }


                } else {
                    if (String(res.data.msgwebapp).length > 0) toast.error(res.data.msgwebapp, {
                        position: "top-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }

            }).catch((err) => {
            console.log(err, "errerrerr");
            /// Setloadinghkfullshow("false");
            toast.error('خطای اتصال به سرور کد 435346', {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        });


    }


    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const drawer = (
        <div>
            {
                page_info_data.length == 0 || page_info_data.Lessons.length == 0 ? (

                    <>

                    </>

                ) : (
                    <>
                        {/*<Meeting_view data_lessons={page_info_data.Lessons} />*/}
                    </>

                )}


        </div>
    );

    const container = window !== undefined ? () => window().document.body : undefined;


    return (
        <>
            <div>
                <ReactFullPageLoadinghk loadinghk={loadinghkfullshow}/>
                <ToastContainer/>

                <Fragment>
                    <ToastContainer/>

                    {


                        (() => {

                            if (status_messege_buy_course == false) {
                                return (
                                    <Fragment>
                                        <Grid container direction="row" spacing={1}>


                                            <Grid className="box_side_bar_metting_panel" lg={4} md={4} sm={12} sx={12}>
                                                <div className={"full_box_side_bar"}>

                                                    <div className={"page_info_top_bar"}>
                                                        <Link to={'/'} className="flexRowStartCenter" style={{
                                                            "paddingRight": "7px",
                                                            "fontSize": "12px",
                                                            "marginTop": "14px",
                                                            "color": "white",
                                                            "backgroundColor": "#2a2929",
                                                            "width": "163px",
                                                            "paddingTop": "11px",
                                                            "paddingBottom": "11px",
                                                            "borderRadius": "8px",
                                                            "textAlign": "center"
                                                        }}>
                                                            <svg fill="#fffff" height="20"
                                                                 style={{color: 'white', fill: 'white'}}
                                                                 viewBox="0 0 20 20" width="20"
                                                                 xmlns="http://www.w3.org/2000/svg">
                                                                <path
                                                                    d="M12.0248 15.6833C11.8664 15.6833 11.7081 15.625 11.5831 15.5C11.3414 15.2583 11.3414 14.8583 11.5831 14.6167L16.1998 10L11.5831 5.38334C11.3414 5.14167 11.3414 4.74167 11.5831 4.50001C11.8248 4.25834 12.2248 4.25834 12.4664 4.50001L17.5248 9.55834C17.7664 9.80001 17.7664 10.2 17.5248 10.4417L12.4664 15.5C12.3414 15.625 12.1831 15.6833 12.0248 15.6833Z"
                                                                    fill="#475569" style={{fill: 'white'}}/>
                                                                <path
                                                                    d="M16.9415 10.625H2.9165C2.57484 10.625 2.2915 10.3417 2.2915 10C2.2915 9.65833 2.57484 9.375 2.9165 9.375H16.9415C17.2832 9.375 17.5665 9.65833 17.5665 10C17.5665 10.3417 17.2832 10.625 16.9415 10.625Z"
                                                                    fill="#475569" style={{fill: 'white'}}/>
                                                            </svg>
                                                            بازگشت به صفحه اصلی
                                                        </Link>


                                                        <div className="title_cource_panel_view">

                                                            <div style={{
                                                                "lineHeight": "1.6",
                                                                "fontSize": "13px",
                                                                "color": "white",
                                                                "padding": "8px",
                                                                "borderRadius": "3px",
                                                                "width": "100%",
                                                                "marginTop": "13px"
                                                            }}>{page_info_data.title_post}</div>
                                                            {/*<div style={{"marginTop":"18px","color":"rgb(235, 38, 38)","marginRight":"5px","marginBottom":"6px","lineHeight":"1.6",}}>*/}
                                                            {/*    {page_info_data.title_full_subtitle}*/}
                                                            {/*</div>*/}
                                                        </div>


                                                    </div>


                                                    {
                                                        page_info_data.length == 0 || page_info_data.Lessons.length == 0 ? (

                                                            <>
                                                                Loading
                                                            </>

                                                        ) : (

                                                            <>
                                                                <Meeting_view id_grupe={page_info_data.id_grupe}
                                                                              id_fhater={page_info_data.id_fhater}
                                                                              cource_id_get={page_info_data.id_post}
                                                                              data_lessons={page_info_data.Lessons}
                                                                              page_view={'panel'}
                                                                              data_info_details={page_info_data}
                                                                              lesson_id={lesson_id}
                                                                              post_type={post_type}
                                                                />
                                                            </>

                                                        )}


                                                </div>

                                            </Grid>

                                            <Grid component="main" lg={8} md={8} sm={12} sx={12}>

                                                {
                                                    page_info_data.length == 0 ? (

                                                        <>
                                                            Loading
                                                        </>

                                                    ) : (
                                                        <Fragment>


                                                            {palyer_type == "nega_new" ? (
                                                                <div className="arvanplayer_box_view" style={{"display": "block"}}>
                                                                    <NegavidNewPlayerComponent key={page_info_data.id_lesson + '-video'}
                                                                        embed={page_info_data.video_lesson} mediaType="video"
                                                                        message={page_info_data.negavid_player_message}/>
                                                                </div>
                                                            ) : palyer_type == "negapodcast_new" ? (
                                                                <div className="arvanplayer_box_view" style={{"display": "block"}}>
                                                                    <NegavidNewPlayerComponent key={page_info_data.id_lesson + '-podcast'}
                                                                        embed={page_info_data.video_lesson_podcast} mediaType="audio"
                                                                        message={page_info_data.negavid_player_message}/>
                                                                </div>
                                                            ) : palyer_type == "arvan" ? (
                                                                <div className="arvanplayer_box_view"
                                                                     style={{"display": "block"}}>
                                                                    <ArvanPlayerComponent
                                                                        configUrl={String(page_info_data.video_lesson)}/>
                                                                </div>
                                                            ) : palyer_type == "nega" ? (
                                                                <div className="arvanplayer_box_view"
                                                                     style={{"display": "block"}}>
                                                                    <NegavidPlayerComponent
                                                                        id_video={String(page_info_data.video_lesson)}/>
                                                                </div>) : palyer_type == "negapodcast" ? (
                                                                <div className="arvanplayer_box_view"
                                                                     style={{"display": "block"}}>
                                                                    <NegavidPlayer_pocast_Component
                                                                        id_video={String(page_info_data.video_lesson_podcast)}/>
                                                                </div>
                                                            ) : (
                                                                <div className="arvanplayer_box_view"
                                                                     style={{"display": "block"}}>
                                                                    <Plyr_online_Component
                                                                        src_video={String(page_info_data.video_lesson)}/>
                                                                </div>
                                                            )

                                                            }


                                                            <div className="flexRowBetCenter pack-nav-wrapper"
                                                                 style={{"display": "none"}}>
                                                                <span>درس قبلی</span>
                                                                <span>درس بعدی</span>
                                                            </div>

                                                        </Fragment>

                                                    )}

                                            </Grid>


                                        </Grid>

                                    </Fragment>

                                );

                            } else {


                                return (

                                    <Fragment>


                                        <div style={{
                                            "placeContent": "center",
                                            "display": "flex",
                                            "flexDirection": "row",
                                            "paddingTop": "25vh"
                                        }}>


                                            <div style={{
                                                "width": "93%",
                                                "textAlign": "center",
                                                "backgroundColor": "white",
                                                "paddingRight": "4%",
                                                "paddingLeft": "4%"
                                            }}>

                                                <img style={{"width": "100px", "marginTop": "38px"}}
                                                     src={clientconfigwebapp.webappurl + "images/icon_lock_v1.png"}/>
                                                <div style={{
                                                    "display": "block",
                                                    "fontSize": "15px",
                                                    "fontFamily": "iranyekan",
                                                    "marginBottom": "31px",
                                                    "marginTop": "18px"
                                                }}>

                                                    <Alert severity="warning" style={{"justifyContent": "center"}}>

                                                        <span style={{
                                                            "fontSize": "1.2rem",
                                                            "fontWeight": "normal",
                                                            "fontFamily": "'iran'",
                                                            "paddingTop": "10px",
                                                            "position": "relative",
                                                            "top": "2px",
                                                            "paddingRight": "3px"
                                                        }}>کاربرگرامی شما دوره را خریداری نکرده اید!</span>

                                                    </Alert>

                                                    <Grid
                                                        justifyContent="center"
                                                        alignItems="center"
                                                        container
                                                    >
                                                        <Link style={{"margin": "8px", "marginTop": "27px"}} to={"/"}
                                                              className="btn-bh btn-grey-bh">
                                                            صفحه اصلی
                                                        </Link>
                                                    </Grid>

                                                </div>


                                            </div>

                                        </div>


                                    </Fragment>
                                )

                            }


                        })()


                    }

                </Fragment>


            </div>

        </>
    );
}


export default Metting_Panel;
